import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import http from "../../http/index";
import { Pill, PillList } from "../../../../domain/entities/pill";
import PillInterface from "./pill_interface";

class PillRepository implements PillInterface {
  async list(index: number): Promise<PillList> {
    return wrapErrorHandler<PillList>(async () => {
      const response = await http.get(`/api/decola/pills`, {
        params: { index, limit: 11 }
      });
      return response.data;
    });
  }

  async get(id: number): Promise<Pill> {
    return wrapErrorHandler<Pill>(async () => {
      const response = await http.get(`/api/decola/pills/${id}`);
      return response.data;
    });
  }

  async watch(id: number): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return http.post(`/api/decola/pills/${id}/watch`);
    });
  }
}

export default new PillRepository() as PillInterface;
